import { render, staticRenderFns } from "./Elecciones.vue?vue&type=template&id=35527511&scoped=true&"
import script from "./Elecciones.vue?vue&type=script&lang=ts&"
export * from "./Elecciones.vue?vue&type=script&lang=ts&"
import style0 from "./Elecciones.vue?vue&type=style&index=0&id=35527511&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35527511",
  null
  
)

export default component.exports